"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalSyncOption = exports.BackendSyncOption = exports.RegionsOperator = exports.SignedIabAgreementOption = exports.UspapiOption = exports.CspOption = exports.ConsentPrecedenceOption = exports.TelemetryPartitionStrategy = exports.UnknownRequestPolicy = exports.ConsentBundleType = exports.DataFlowScope = exports.ConsentTrackerStatus = exports.ConsentTrackerSource = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * The source that set the data flow or cookie
 */
var ConsentTrackerSource;
(function (ConsentTrackerSource) {
    /** The data flow was manually set */
    ConsentTrackerSource["Manual"] = "MANUAL";
    /** The data flow originated from a site-scan */
    ConsentTrackerSource["Scan"] = "SCAN";
    /** Data flow originated from telemetry data */
    ConsentTrackerSource["Telemetry"] = "TELEMETRY";
})(ConsentTrackerSource || (exports.ConsentTrackerSource = ConsentTrackerSource = {}));
/**
 * Statuses for a data flow or cookie
 */
var ConsentTrackerStatus;
(function (ConsentTrackerStatus) {
    /** Data flows or cookies that are to be included in live airgap bundles */
    ConsentTrackerStatus["Live"] = "LIVE";
    /** Data flows or cookies that won't be included in live airgap bundles because they need a human review */
    ConsentTrackerStatus["NeedsReview"] = "NEEDS_REVIEW";
})(ConsentTrackerStatus || (exports.ConsentTrackerStatus = ConsentTrackerStatus = {}));
/**
 * Applicable data flow scopes for a given URL
 */
exports.DataFlowScope = (0, type_utils_1.makeEnum)({
    Host: 'HOST',
    Path: 'PATH',
    QueryParam: 'QUERY_PARAM',
    RegExp: 'REGEX',
    CSP: 'CSP',
});
exports.ConsentBundleType = (0, type_utils_1.makeEnum)({
    /** Bundle hosted at /cm path */
    Production: 'PRODUCTION',
    /** Bundle hosted at /cm-test path */
    Test: 'TEST',
});
exports.UnknownRequestPolicy = (0, type_utils_1.makeEnum)({
    Allow: 'ALLOW',
    RequireFullConsent: 'REQUIRE_FULL_CONSENT',
    Block: 'BLOCK',
});
exports.TelemetryPartitionStrategy = (0, type_utils_1.makeEnum)({
    /** Partition telemetry data by the origin (default) */
    Origin: 'origin',
    /** Partition telemetry data by the origin + path */
    Path: 'path',
    /** Partition telemetry data by the full URL */
    Url: 'url',
});
/**
 * The possible options for configuring the Consent resolution precedence
 *
 * If this is set to 'user' (default), then confirmed consent is persisted, even
 * if the consent opts the user into tracking purposes opted out by the user's
 * detected privacy signals.
 *
 * If this is set to 'signals', then detected privacy signals always take precedence
 * over confirmed consent.
 */
exports.ConsentPrecedenceOption = (0, type_utils_1.makeEnum)({
    User: 'user',
    Signal: 'signal',
});
/**
 * The possible options for configuring the CSP
 *
 * These options are simplified for the UI.
 * Their equivalence in the airgap.js browser API:
 * Strict => strict
 * Lax => allow-subdomains allow-known-hosts
 * On => allow-subdomains
 * Off => off
 */
exports.CspOption = (0, type_utils_1.makeEnum)({
    Strict: 'Strict',
    Lax: 'Lax',
    On: 'On',
    Off: 'Off',
});
/**
 * Options for configuring the US Privacy API
 *
 * On
 * Off
 */
exports.UspapiOption = (0, type_utils_1.makeEnum)({
    On: 'on',
    Off: 'off',
});
/**
 * Options for configuring the US Privacy API
 *
 * Yes
 * No
 * Unknown
 */
exports.SignedIabAgreementOption = (0, type_utils_1.makeEnum)({
    Yes: 'yes',
    No: 'no',
    Unknown: 'unknown',
});
/**
 * Describes whether listed countries/country subdivisions are included in an experience
 */
exports.RegionsOperator = (0, type_utils_1.makeEnum)({
    /** The listed countries/country subdivisions, time zones, and languages are included in this experience */
    In: 'IN',
    /** The listed countries/country subdivisions, time zones, and languages are NOT included in this experience */
    NotIn: 'NOT_IN',
});
/**
 * Options for configuring Backend Sync
 *
 * On
 * Off
 */
exports.BackendSyncOption = (0, type_utils_1.makeEnum)({
    On: 'on',
    Off: 'off',
});
/**
 * Whether or not to run local on-device same-site cross-domain sync
 *
 * default: 'on'
 */
exports.LocalSyncOption = (0, type_utils_1.makeEnum)({
    /** use private sync only */
    Private: 'private',
    /** allow network-observable sync when private sync is unavailable */
    AllowNetworkObservable: 'allow-network-observable',
    /** comparable to 'allow-network-observable' -- allow network-observable sync when private sync is unavailble */
    On: 'on',
    /** disable local sync */
    Off: 'off',
});
//# sourceMappingURL=consentManager.js.map